import React, { useState, useEffect } from 'react';
import { ImProfile } from "react-icons/im";
import { CgProfile } from "react-icons/cg";
import './schedule.css';
import axios from 'axios';

export default function MySchedule() {
  const [scheduleData, setScheduleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null); // State for user data
  const userId = localStorage.getItem('userId'); // Get userId from localStorage
  const username = localStorage.getItem('name'); // Changed to 'name' to match the signin save

  // Function to fetch user profile data
  const fetchUserProfile = async () => {
    try {
      const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/user/user/${userId}`);
      setUser(response.data);  // Storing the user data
    } catch (error) {
      console.error("Error fetching user profile:", error);
      if (error.response && error.response.status === 404) {
        console.error("User profile not found");
      }       
    }
  };

  // Function to fetch timing data
  const fetchTimingData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/timings/${userId}`);
      setScheduleData(response.data ? [response.data] : []);
    } catch (error) {
      console.error("Error fetching timing data:", error);
      if (error.response && error.response.status === 404) {
        console.error("Timing data not found");
      }
    } finally {
      setLoading(false);
    }
  };

  // UseEffect to call both fetch functions
  useEffect(() => {
    if (userId) {
      fetchUserProfile();
      fetchTimingData();
    } else {
      console.error("User ID not found in session storage");
    }
  }, [userId]);

  return (
    <div className='container-schedule'>
      <div>
        <h1 className="schedule-header">
          <ImProfile />
          Employee's Schedule
        </h1>
        <hr className='divider' />
        <h1 className="schedule-subheader">
          <CgProfile />
          {username ? `${username}` : 'Welcome, Guest!'}
        </h1>
        <hr className='subdivider' />
      </div>
      <div className="schedule-table-container">
        <div className="table-responsive">
          <table className='table table-striped'>
            <thead>
              <tr className='schedule-table-header'>
                <th>Employee Name</th>
                <th>Department</th>
                <th>Shift</th>
                <th>Check-In Time</th>
                <th>Check-Out Time</th>
                <th>Break-In Time</th>
                <th>Break-Out Time</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="7" className="text-center">Loading...</td></tr>
              ) : (
                user && scheduleData.length > 0 ? (
                  scheduleData.map((item, index) => (
                    <tr key={index} className="schedule-table-row">
                      <td>{user.name}</td> {/* Safely access user.name */}
                      <td>{user.department?.name || "N/A"}</td>
                      <td>{item.shift || 'N/A'}</td>
                      <td>{item.shiftStart || 'N/A'}</td>
                      <td>{item.shiftEnd || 'N/A'}</td>
                      <td>{item.breakStart || 'N/A'}</td>
                      <td>{item.breakEnd || 'N/A'}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="7" className="text-center">No schedule data available</td></tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
